// Embedded lookup table from legacy cast-iron-radiator-power-calc-data.json
// Each type maps to an array of 24 watt values (index 0 = 2 elements, index 23 = 25 elements)
// These base values are at deltaT = 60
const CAST_IRON_DATA = {
  'S-130': [240, 360, 471, 582, 692, 797, 901, 1012, 1116, 1221, 1326, 1425, 1529, 1634, 1733, 1838, 1936, 2041, 2140, 2239, 2338, 2436, 2541, 2640],
  'T-1': [308, 465, 622, 727, 872, 1018, 1163, 1262, 1401, 1540, 1680, 1820, 1960, 2100, 2239, 2378, 2518, 2657, 2797, 2878, 3018, 3152, 3291, 3425],
  'TA-1': [370, 558, 746, 872, 1046, 1222, 1396, 1514, 1681, 1848, 2016, 2184, 2352, 2520, 2687, 2854, 3022, 3188, 3356, 3454, 3622, 3782, 3949, 4110],
}

const N_EXPONENT = 1.25
const BASELINE_DELTA_T = 60

export const castIronData = {
  types: Object.keys(CAST_IRON_DATA),
  minElements: 2,
  maxElements: 25,
}

function calculateDeltaT(flow, returnTemp, room) {
  const deltaIn = flow - room
  const deltaOut = returnTemp - room

  if (deltaIn <= 0 || deltaOut <= 0) return 0

  if (Math.abs(deltaIn - deltaOut) < 0.001) {
    return (deltaIn + deltaOut) / 2
  }

  return (deltaIn - deltaOut) / Math.log(deltaIn / deltaOut)
}

export function castIronWatts(type, numberOfElements, flow, returnTemp, room) {
  const values = CAST_IRON_DATA[type]
  if (!values) return 0

  if (numberOfElements < 2 || numberOfElements > 25) return 0
  const index = numberOfElements - 2
  if (index >= values.length) return 0

  const baseWatts = values[index]
  const deltaT = calculateDeltaT(flow, returnTemp, room)
  if (deltaT <= 0) return 0

  return Math.round(baseWatts * Math.pow(deltaT / BASELINE_DELTA_T, N_EXPONENT))
}
